import appRoutes from '@/router/routes/app';
import authRoutes from '@/router/routes/auth';

let routes = [];

routes = [...routes, ...authRoutes];
routes = [...routes, ...appRoutes];

export default routes;
